import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useNavigationControl } from './useNavigationControl';
export * from './useNavigationControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    navigationControl
  } = useNavigationControl(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    navigationControl
  }), [navigationControl]);
  return null;
});